import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    StyledSelectedContainer,
    StyledContainer,
    StyledDropdownMenu,
    StyledDropdownMenuItem,
    SortIconWrapper,
} from './Dropdown.style';
import { DropdownState } from './Dropdown.state';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { CheckMark } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/dropdown/icons/CheckMark';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

type DropdownOptionType = {
    label: string;
    value: string;
    onClick: VoidFunction;
};

interface DropdownPropsType {
    selected: string | null;
    options: DropdownOptionType[];
}

export const Dropdown = observer('Dropdown', (propsIn: DropdownPropsType): JSX.Element => {
    const { options, selected } = useAsObservableSource(propsIn);
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const [{ handleOpen, open }] = React.useState(() => new DropdownState());

    return (
        <StyledContainer>
            <SortIconWrapper onClick={handleOpen} />

            {open ? (
                <StyledDropdownMenu variant={configState.componentVariants.sportsbookVariant}>
                    {options.map(({ label, onClick, value }) => {
                        const handleClick = (): void => {
                            onClick();
                            handleOpen();
                        };
                        const isSelected = selected === value;

                        return (
                            <StyledSelectedContainer
                                selected={isSelected}
                                onClick={handleClick}
                                key={value}
                            >
                                <StyledDropdownMenuItem>{label}</StyledDropdownMenuItem>
                                {isSelected && <CheckMark />}
                            </StyledSelectedContainer>
                        );
                    })}
                </StyledDropdownMenu>
            ) : null}
        </StyledContainer>
    );
});
